<template>
  <!-- 申请试用 -->
  <section class="apply-section" ref="applySection">
    <div class="container">
      <div class="apply-content">
        <h2 class="title">{{ $t('apply.title') }}</h2>
        <p class="subtitle">{{ $t('apply.subtitle') }}</p>

        <form class="apply-form" @submit.prevent="handleSubmit">
          <div class="form-grid">
            <div class="form-item">
              <label class="form-label"><span class="required">*</span>{{ $t('apply.company') }}</label>
              <input class="form-input" type="text" v-model="form.company" :placeholder="$t('apply.companyPlaceholder')" />
            </div>
            <div class="form-item">
              <label class="form-label"><span class="required">*</span>{{ $t('apply.city') }}</label>
              <input class="form-input" type="text" v-model="form.city" :placeholder="$t('apply.cityPlaceholder')" />
            </div>
            <div class="form-item">
              <label class="form-label"><span class="required">*</span>{{ $t('apply.phone') }}</label>
              <input class="form-input" type="text" v-model="form.phone" :placeholder="$t('apply.phonePlaceholder')" />
            </div>
            <div class="form-item">
              <label class="form-label"><span class="required">*</span>{{ $t('apply.code') }}</label>
              <div class="code-row">
                <input class="form-input code-input" type="text" v-model="form.code" :placeholder="$t('apply.codePlaceholder')" />
                <button type="button" class="code-btn" :disabled="codeTime > 0" @click="sendCode">
                  {{ codeTime > 0 ? $t('apply.retry', { n: codeTime }) : $t('apply.getCode') }}
                </button>
              </div>
            </div>
          </div>
          <div class="form-item">
            <div class="code-row">
              <textarea v-model="form.remark" class="form-input" :placeholder="$t('apply.remarkPlaceholder')"></textarea>
            </div>
          </div>
          <button type="submit" class="submit-btn">{{ $t('apply.submit') }}</button>
        </form>

        <div class="concat-container">
          <div class="contact">{{ $t('apply.contactText') }}</div>
          <div class="phone">187-5561-5081</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { request } from '@/utils/request'

export default {
  name: 'ApplySection',
  data() {
    return {
      apiBase: '/api',
      codeTime: 0,
      codeTimer: null,
      form: {
        company: '',
        city: '',
        phone: '',
        code: '',
        remark: '',
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.codeTimer)
  },
  methods: {
    isValidPhone(phone) {
      return this.$i18n.locale === 'zh'
        ? /^1[3-9]\d{9}$/.test(phone)
        : /^[0-9+\-\s]{6,20}$/.test(phone)
    },
    async sendCode() {
      if (!this.isValidPhone(this.form.phone)) {
        this.$toast({
          type: 'error',
          message: this.$t('apply.msgInvalidPhone')
        })
        return
      }
      try {
        const response = await request(`${this.apiBase}/system/aichange/sendSms`, {
          params: { number: this.form.phone }
        })
        if (response && response.status === 200) {
          this.$toast({ type: 'success', message: this.$t('apply.msgCodeSent') })
          this.startCodeTimer()
        } else {
          this.$toast({ type: 'error', message: this.$t('apply.msgCodeFail') })
        }
      } catch (error) {
        console.error(error)
        this.$toast({ type: 'error', message: this.$t('apply.msgCodeError') })
      }
    },
    startCodeTimer() {
      this.codeTime = 60
      clearInterval(this.codeTimer)
      this.codeTimer = setInterval(() => {
        this.codeTime--
        if (this.codeTime <= 0) clearInterval(this.codeTimer)
      }, 1000)
    },
    async handleSubmit() {
      if (!this.form.company || !this.form.city || !this.form.phone || !this.form.code) {
        this.$toast({ type: 'error', message: this.$t('apply.msgIncomplete') })
        return
      }
      try {
        const response = await request(`${this.apiBase}/system/capture`, {
          method: 'POST',
          data: {
            company: this.form.company,
            phone: this.form.phone,
            city: this.form.city,
            code: this.form.code,
            remark: this.form.remark
          }
        })
        const data = response && response.data
        if (data && data.code === 200) {
          this.$toast({ type: 'success', message: data.msg || this.$t('apply.msgSubmitSuccess') })
          this.form = { company: '', city: '', phone: '', code: '', remark: '' }
        } else {
          this.$toast({ type: 'error', message: (data && data.msg) || this.$t('apply.msgSubmitFail') })
        }
      } catch (error) {
        console.error(error)
        this.$toast({ type: 'error', message: this.$t('apply.msgSubmitError') })
      }
    }
  }
}
</script>

<style scoped>
.apply-section {
  position: relative;
  z-index: 1;
  background: linear-gradient(to bottom, #F4EDFF 0%, #FFFFFF 54%, #E3F2FF 100%);
  padding: var(--section-padding) 0;
}
.container {
  max-width: var(--container-max);
  margin: 0 auto;
  padding: 0 var(--container-padding);
}
.apply-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.apply-content .title {
  font-size: var(--title-size);
  font-weight: var(--fw-bold);
  color: var(--c-navy);
  font-family: var(--font-base);
  margin: 0 0 12px;
  line-height: var(--lh-snug);
}
.apply-content .subtitle {
  font-size: var(--fs-h2);
  font-weight: var(--fw-light);
  color: var(--c-text-3);
  font-family: var(--font-base);
  margin: 0 0 48px;
  line-height: var(--lh-snug);
}
.concat-container {
  margin-top: var(--sp-15);
}
.concat {
  color: var(--c-muted);
  font-size: var(--fs-xs);
  line-height: 30px;
  font-family: var(--font-base);
}
.phone {
  background: var(--grad-btn);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  font-size: var(--fs-h3);
  font-weight: var(--fw-bold);
  font-family: var(--font-base);
}
.apply-form {
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.form-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 2rem;
  row-gap: 1.5rem;
}
.form-item {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.form-label {
  font-size: var(--fs-base);
  font-weight: var(--fw-medium);
  color: var(--c-navy);
  font-family: var(--font-base);
  margin-bottom: 8px;
}
.required {
  color: #e5484d;
  margin-right: 2px;
}
.form-input {
  width: 100%;
  height: 52px;
  padding: 0 var(--sp-4);
  font-size: var(--fs-base);
  font-family: inherit;
  color: var(--c-navy);
  background: var(--c-white);
  border: 1px solid var(--c-line);
  border-radius: var(--r-sm);
  outline: none;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  box-sizing: border-box;
}
.form-input::placeholder {
  color: var(--c-muted);
}
.form-input:focus {
  border-color: var(--c-blue);
  box-shadow: 0 0 0 3px rgba(10, 132, 244, 0.12);
}
.apply-form > .form-item {
  width: 100%;
  margin-top: 1.5rem;
}
.apply-form > .form-item .code-row {
  width: 100%;
}
textarea.form-input {
  height: 120px;
  padding: var(--sp-3) var(--sp-4);
  resize: vertical;
  line-height: var(--lh-normal);
}
.code-row {
  display: flex;
  gap: var(--sp-3);
}
.code-input {
  flex: 1;
}
.code-btn {
  flex-shrink: 0;
  height: 52px;
  padding: 0 var(--sp-5);
  background: var(--grad-btn);
  color: var(--c-white);
  border: none;
  border-radius: var(--r-sm);
  font-size: var(--fs-sm);
  font-weight: var(--fw-medium);
  font-family: var(--font-base);
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.3s ease;
}
.code-btn:hover {
  background: var(--grad-btn-hover);
}
.code-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.submit-btn {
  margin-top: 2.5rem;
  padding: var(--sp-4) 72px;
  background: var(--grad-btn);
  color: var(--c-white);
  border: none;
  border-radius: var(--r-pill);
  font-size: var(--fs-md);
  font-weight: var(--fw-semibold);
  font-family: var(--font-base);
  cursor: pointer;
  box-shadow: var(--shadow-blue);
  transition: all 0.3s ease;
}
.submit-btn:hover {
  background: var(--grad-btn-hover);
  transform: translateY(-3px);
  box-shadow: 0 12px 32px rgba(10, 132, 244, 0.4);
}
@media (max-width: 768px) {
  .apply-content .title {
    font-size: var(--fs-h2);
  }
  .apply-content .subtitle {
    font-size: var(--fs-md);
    margin-bottom: 2rem;
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
  .submit-btn {
    width: 100%;
    padding: var(--sp-3) 0;
  }
}
@media (max-width: 480px) {
  .apply-content .title {
    font-size: var(--fs-h3);
  }
  .apply-content .subtitle {
    font-size: var(--fs-base);
  }
  .form-input {
    height: 44px;
    font-size: var(--fs-sm);
  }
  .code-btn {
    height: 44px;
    padding: 0 var(--sp-4);
    font-size: var(--fs-xs);
  }
  .submit-btn {
    font-size: var(--fs-base);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ApplySection.vue